/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
/* ==========================================================
   EVELINE — CART RECOMMENDATION AJAX ADD
========================================================== */

document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-ev-cart-add]');

  if (!button) return;

  event.preventDefault();

  const variantId = button.dataset.variantId;
  const buttonText = button.querySelector('span:first-child');

  if (!variantId || button.disabled) return;

  const originalText = buttonText
    ? buttonText.textContent
    : 'Sepete Ekle';

  button.disabled = true;
  button.classList.add('is-loading');

  if (buttonText) {
    buttonText.textContent = 'Ekleniyor...';
  }

  try {
    const addResponse = await fetch(
      window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart/add.js`
        : '/cart/add.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      }
    );

    if (!addResponse.ok) {
      throw new Error('Ürün sepete eklenemedi.');
    }
    window.location.reload();
return;

    if (buttonText) {
      buttonText.textContent = 'Sepete Eklendi ✓';
    }

    button.classList.remove('is-loading');
    button.classList.add('is-added');
button.disabled = false;

document.dispatchEvent(
  new CustomEvent('theme:cart:reload')
);

/* Güncel sepet toplamını ödeme butonuna yansıt */
const cartResponse = await fetch(
  window.Shopify?.routes?.root
    ? `${window.Shopify.routes.root}cart.js`
    : '/cart.js',
  {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    },
    credentials: 'same-origin'
  }
);

if (!cartResponse.ok) {
  throw new Error('Güncel sepet toplamı alınamadı.');
}

const updatedCart = await cartResponse.json();

const formatCartMoney = function (amount) {
  if (
    window.Shopify &&
    typeof window.Shopify.formatMoney === 'function'
  ) {
    return window.Shopify.formatMoney(amount);
  }

  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format(amount / 100)
    .replace('₺', '')
    .trim() + '₺';
};

window.setTimeout(function () {
  document.querySelectorAll('[data-cart-final]').forEach(function (element) {
    element.textContent = formatCartMoney(updatedCart.total_price);
  });
}, 250);

const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

if (cartDrawer) {
  cartDrawer.dispatchEvent(
    new CustomEvent('theme:drawer:open', {
      bubbles: false
    })
  );
}

  } catch (error) {
    console.error('Eveline cart recommendation error:', error);

    button.disabled = false;
    button.classList.remove('is-loading', 'is-added');

    if (buttonText) {
      buttonText.textContent = 'Tekrar Dene';
    }

    window.setTimeout(function () {
      if (buttonText) {
        buttonText.textContent = originalText;
      }
    }, 1800);
  }
});


/* =========================================================
   EVELINE — BANNERDAN NAIL THERAPY ASİSTANINA GEÇİŞ
   Pipeline mobil menüsünün açılmasını engeller.
========================================================= */

document.addEventListener(
  'click',
  function (event) {
    const assistantLink = event.target.closest(
      'a[href="#nail-therapy-assistant"], ' +
      'a[href="/#nail-therapy-assistant"], ' +
      'a[href*="#nail-therapy-assistant"]'
    );

    if (!assistantLink) return;

    /*
     * Pipeline temasının aynı tıklamayı menü/drawer işlemi
     * olarak yorumlamasını daha oluşmadan engeller.
     */
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const target = document.getElementById('nail-therapy-assistant');

    if (!target) {
      window.location.href = '/#nail-therapy-assistant';
      return;
    }

    /*
     * Her ihtimale karşı açık olabilecek menü drawer'ını kapat.
     */
    const openDrawers = document.querySelectorAll(
      '[data-drawer].is-open, ' +
      '[data-drawer][open], ' +
      '.drawer.is-open, ' +
      '.drawer--visible, ' +
      '.menu-drawer.is-open, ' +
      '[aria-hidden="false"][class*="drawer"]'
    );

    openDrawers.forEach(function (drawer) {
      drawer.dispatchEvent(
        new CustomEvent('theme:drawer:close', {
          bubbles: true
        })
      );

      drawer.classList.remove(
        'is-open',
        'drawer--visible',
        'is-visible',
        'open'
      );

      drawer.setAttribute('aria-hidden', 'true');
    });

    /*
     * Sayfa kaydırma kilidini tamamen kaldır.
     */
    document.documentElement.classList.remove(
      'overflow-hidden',
      'menu-open',
      'drawer-open',
      'js-drawer-open'
    );

    document.body.classList.remove(
      'overflow-hidden',
      'menu-open',
      'drawer-open',
      'js-drawer-open'
    );

    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('position');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');

    /*
     * Doğrudan analiz bölümüne yumuşak geçiş.
     */
    window.requestAnimationFrame(function () {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      history.replaceState(
        null,
        '',
        window.location.pathname +
          window.location.search +
          '#nail-therapy-assistant'
      );
    });
  },
  true
);
/* =========================================================
   EVELINE — ÜCRETSİZ KARGO HESABI
   Kargo ücretini hesaba katmaz, yalnızca ürün toplamını kullanır.
========================================================= */

(function () {
  const updateFreeShippingMessage = (cart) => {
    if (!cart || typeof cart.total_price !== 'number') return;

    document.querySelectorAll('[data-cart-message][data-limit]').forEach((message) => {
      const limitTL = Number(message.getAttribute('data-limit')) || 650;
      const limitCents = Math.round(limitTL * 100);
      const productTotalCents = cart.total_price;
      const remainingCents = Math.max(limitCents - productTotalCents, 0);

      const remainingElement = message.querySelector('[data-left-to-spend]');
      const defaultMessage = message.querySelector('.cart__message-default');
      const successMessage = message.querySelector('.cart__message-success');

      const qualifies = productTotalCents >= limitCents;

      message.classList.toggle('is-success', qualifies);

      if (defaultMessage) {
        defaultMessage.style.display = qualifies ? 'none' : '';
      }

      if (successMessage) {
        successMessage.style.display = qualifies ? '' : 'none';
      }

      if (!qualifies && remainingElement) {
        const remainingTL = remainingCents / 100;

        remainingElement.textContent = new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY',
          minimumFractionDigits: remainingTL % 1 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(remainingTL);
      }

      const percent = Math.min(
        100,
        Math.max(0, (productTotalCents / limitCents) * 100)
      );

      message.querySelectorAll('[data-cart-progress]').forEach((circle) => {
        circle.setAttribute('data-percent', String(percent));

        const circumference = 87.96459430051421;
        const offset = circumference - ((percent / 100) * circumference) / 2;
        circle.style.strokeDashoffset = String(offset);
      });
    });
  };

  document.addEventListener('theme:cart:change', (event) => {
    updateFreeShippingMessage(event.detail && event.detail.cart);
  });
})();
/* =========================================================
   EVELINE — CART DRAWER DYNAMIC TOTALS
   Ürün adedi değiştiğinde kargo, toplam ve butonu günceller.
========================================================= */

(() => {
  const FREE_SHIPPING_LIMIT = 65000; // 650 TL, kuruş cinsinden
  const SHIPPING_PRICE = 0;

  const formatMoney = (amountInCents) => {
    const amount = amountInCents / 100;

    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount) + '₺';
  };

  const updateDrawerTotals = (cart) => {
    if (!cart || typeof cart.total_price !== 'number') return;

    
    const productTotal = cart.total_price;

/*
 * Ücretsiz kargo kontrolü indirim öncesi ürün toplamına göre yapılır.
 * Ödenecek toplam ise indirim sonrası cart.total_price üzerinden hesaplanır.
 */
const freeShippingQualifyingTotal =
  typeof cart.original_total_price === 'number'
    ? cart.original_total_price
    : cart.total_price;

const shippingPrice =
  freeShippingQualifyingTotal >= FREE_SHIPPING_LIMIT
    ? 0
    : SHIPPING_PRICE;

const displayedTotal = productTotal + shippingPrice;

    document
      .querySelectorAll('[data-ev-shipping-price]')
      .forEach((element) => {
        element.textContent =
          shippingPrice === 0
            ? 'Ücretsiz'
            : formatMoney(shippingPrice);
      });

    document
      .querySelectorAll('[data-ev-summary-total]')
      .forEach((element) => {
        element.textContent = formatMoney(displayedTotal);
      });

    document
      .querySelectorAll('[data-ev-drawer-total]')
      .forEach((element) => {
        element.textContent = formatMoney(displayedTotal);
      });
  };

  document.addEventListener('theme:cart:change', (event) => {
    const cart = event.detail && event.detail.cart;

    updateDrawerTotals(cart);
  });
})();